export default [
    {
        name: 'Serviços',
        url: '/gescon/uabs/servicos',
        icon: 'fa fa-truck',
        regras: 'GESCON-UABS-SERV-00',
        badge: {
            variant: 'primary',
            text: 'UABS'
        }
    }
]
